export class CountryList {

    protected element: HTMLElement;

    constructor() {
        this.element = document.querySelector('.c-country-list');

        if  (this.element) {
            this.initLinkHandler();
        }
    }

    initLinkHandler() {
        this.element.querySelectorAll('.c-country-list__link:not(.c-country-list__link--external)').forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                // @ts-ignore Cookies is a global variable
                Cookies.set('bd_routing', 'closed');

                window.location.href = link.getAttribute('href');
            })
        });
    }

}

new CountryList();
